var map = {
  "./cs.json": [
    "r80",
    [
      "p2"
    ]
  ],
  "./en.json": [
    "vZ0",
    [
      "5bd"
    ]
  ],
  "./pl.json": [
    "Nar",
    [
      "3r0"
    ]
  ],
  "./ru.json": [
    "He",
    [
      "dr"
    ]
  ],
  "./tr.json": [
    "kxv",
    [
      "6q"
    ]
  ],
  "./ja.json": [
    "vJ",
    [
      "xg"
    ]
  ],
  "./zh.json": [
    "PN",
    [
      "t2"
    ]
  ],
  "./pt-br.json": [
    "gpG",
    [
      "ys"
    ]
  ],
  "./de.json": [
    "pv",
    [
      "rc"
    ]
  ],
  "./es.json": [
    "t6R",
    [
      "fd"
    ]
  ],
  "./fr.json": [
    "c6",
    [
      65
    ]
  ],
  "./it.json": [
    "Zl",
    [
      "nu"
    ]
  ],
  "./ko.json": [
    "Wc5",
    [
      "kvs"
    ]
  ],
  "./pt.json": [
    "ZY",
    [
      "zaj"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "ms";
module.exports = __rspack_async_context;
